import { createContext, useContext } from 'react';
import { RootStore } from 'store/rootStore';
import { ProposalItemsStore } from 'store/ui-stores/proposal-v2/proposalItemsStore';
import CartItemDelegate from 'store/modules/proposal/delegates/cartItemDelegate';
import ProductLineDelegate from 'store/modules/proposal/delegates/productLineDelegate';
import { INITIAL_CART_ITEM, INITIAL_PORTFOLIO } from 'store/modules/proposal/types';
import RFQProposalPageStore from './pageStore';

type RFQProposalPageDelegate = CartItemDelegate<RFQProposalPageStore>;

const proposalPageStore = new RFQProposalPageStore(new ProposalItemsStore(new RootStore()));

export const CartItemDelegateContext = createContext<RFQProposalPageDelegate>(
  new CartItemDelegate({
    pageStore: proposalPageStore,
    portfolioToCartItem: { portfolio: { ...INITIAL_PORTFOLIO }, cartItem: { ...INITIAL_CART_ITEM } },
    productLineDelegate: new ProductLineDelegate(
      new RFQProposalPageStore(new ProposalItemsStore(new RootStore())),
      null,
    ),
  }),
);

export function useRFQCartItemDelegate(): RFQProposalPageDelegate {
  return useContext(CartItemDelegateContext);
}
